import { type NotificationType } from '@/redux/slices/notificationSlice'
import ItemWrapper from './ItemWrapper'

export default function TradePayoutExport({ notification }: { notification: NotificationType }) {
  const { payoutDate } = notification.activity as { payoutDate?: string | null }
  const prefix = payoutDate ? `${payoutDate} ` : ''

  return <ItemWrapper notification={notification}>{prefix}提现的交易对账单 数据导出成功</ItemWrapper>
}
